import Message from 'formvalidation/plugins/Message';
import Trigger from 'formvalidation/plugins/Trigger';
import SubmitButton from 'formvalidation/plugins/SubmitButton';

import ValidationUtils from '../../utils/validation';

const getValidationRules = (universityCallback = () => true) => ({
	fields: {
		firstName: {
			validators: {
				notEmpty: {
					message: 'Please enter a first name'
				},
				stringLength: {
					min: 2,
					message: 'First name must be 2 or more letters'
				},
				regexp: {
					regexp: /^[a-zA-Z-' ]+$/,
					message: 'Please enter a first name that contains only letters'
				}
			}
		},
		lastName: {
			validators: {
				notEmpty: {
					message: 'Please enter a last name'
				},
				stringLength: {
					min: 2,
					message: 'Last name must be 2 or more letters'
				},
				regexp: {
					regexp: /^[a-zA-Z-' ]+$/,
					message: 'Please enter last name that contains only letters'
				}
			}
		},
		emailAddress: {
			validators: {
				notEmpty: {
					message: 'Please enter an email address'
				},
				regexp: {
					regexp: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/i,
					message: 'Please enter a valid email address'
				}
			}
		},
		gender: {
			validators: {
				notEmpty: {
					message: 'Please select a gender'
				}
			}
		},
		universityStudent: {
			validators: {
				notEmpty: {
					message: 'Please select if you are currently studying at university'
				}
			}
		},
		university: {
			validators: {
				callback: {
					message: 'Please search and select a university',
					callback: universityCallback
				}
			}
		},
		graduationYear: {
			validators: {
				notEmpty: {
					message: 'Please select a graduation year'
				}
			}
		},
		mobilePhone: {
			validators: {
				regexp: {
					regexp: /^\d{10,13}$/,
					message: 'Please enter a valid mobile phone number'
				}
			}
		}
	},
	plugins: {
		// Disable per-field events for `university` and `graduationYear` so that their
		// validators run only during explicit form submission (not on input/change).
		trigger: new Trigger({
			event: {
				university: false,
				graduationYear: false
			},
		}),
		submitButton: new SubmitButton(),
		message: new Message({
			clazz: 'lta-text-input__label-instruction',
			container: function(field, element) {
				let fieldType = element.getAttribute('type') || element.nodeName.toLowerCase();
				const inputWrapper = element.closest(ValidationUtils.getFieldWrapper(fieldType));
				return inputWrapper.querySelector('.lta-text-input--error');
			}
		}),
	}
});

export default getValidationRules;